<template>
    <el-dialog title="申请提现" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <el-form size="small" :model="form" ref="order">
            <div class="red f18 fb p10">温馨提醒</div>
            <div class="red f16 p10"><span class="fb">提现时间：</span> 周一至周五，08:00~17:00，可进行提现操作。</div>
            <div class="red f16 p10"><span class="fb">提现手续费：</span> 每笔交易，扣除1元手续费。</div>
            <el-form-item label="提现金额" :label-width="formLabelWidth" prop="money" :rules="[{ required: true, message: '请输入提现金额' }]">
                <el-input type="number" v-model="form.money" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手续费" :label-width="formLabelWidth">
                <el-input type="number" v-model ="form.commission" autocomplete="off" disabled>
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
            <el-form-item label="打款方式" :label-width="formLabelWidth" prop="pay_type" :rules="[{ required: true, message: '请输入打款方式' }]">
                <!--<el-radio v-model="form.pay_type" :label="10">支付宝</el-radio>-->
                <el-radio v-model="form.pay_type" :label="20">银行卡</el-radio>
                <!-- <el-radio v-model="form.pay_type" :label="30">微信</el-radio> -->
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import cashApi from '@/api/cash.js';

    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                /*表单*/
                form: {
                    money: '',
                    commission: '1',
                    pay_type: 20
                }
            };
        },
        props: [],
        created() {
        },
        methods: {
            // 确认事件
            submitFunc(e) {
                let self = this;

                // 周一至周五，08:00~17:00，可进行提现操作
                if (self.getWeekDay() == '星期六' || self.getWeekDay() == '星期天'){
                    self.$message({
                        message: '当前时间不可提现',
                        type: 'error'
                    });
                    return
                }
                let hour = self.isWithinWorkingHours()

                if (hour < 8){
                    self.$message({
                        message: '当前时间不可提现',
                        type: 'error'
                    });
                    return
                }

                if (hour > 17){
                    self.$message({
                        message: '当前时间不可提现',
                        type: 'error'
                    });
                    return
                }

                self.$refs.order.validate(valid => {
                    if (valid) {
                        self.loading = true;
                        cashApi
                            .apply(self.form, true)
                            .then(res => {
                                self.loading = false;
                                self.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                                self.dialogFormVisible(true);
                            })
                            .catch(error => {
                                self.loading = false;
                            });
                    }
                });
            },

            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            },

            getWeekDay() {
                const now = new Date();
                const weekDayNumber = now.getDay();
                const weekDays = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                return weekDays[weekDayNumber];
            },
            isWithinWorkingHours() {
                const now = new Date()
                const hour = now.getHours()
                return hour
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/cash/dialog/Apply.vue